export const routes = (prefix = `billing`) => [
    {
        name: `${prefix}.proforma-invoice.print`,
        path: `/${prefix}/proforma-invoice/print`,
        component: () => import('./ProformaInvoice.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.proforma-invoice.create`,
                PageDescription: "Accounts: Proforma Invoice",
            },
        },
    },{
        name: `${prefix}.proforma-invoicing.print`,
        path: `/${prefix}/proforma-invoicing/print`,
        component: () => import('./ProformaInvoicing.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.proforma-invoice.create`,
                PageDescription: "Accounts: Proforma Invoice",
            },
        },
    },
];
